<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <v-select
                class="ucFirst body-2 tz-dropdown"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :value="computedValue"
                :name="metadata.name"
                :items="dropBoxOptions"
                item-text="text"
                item-value="option"
                :outline="outline"
                :append-icon="appendIcon"
                :color="$vuetify.theme.primary"
                validate-on-blur
                :rules="[
                    v => !required || v === false || v === true || $t('base.errors.requiredField')
                ]"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { formRules } from '@/mixins/form-rules';
import { mapGetters } from 'vuex';

export default {
    name: 'covid-screening-working-quebec',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: [String, Boolean, Number], required: false, default: '' },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

        appendIcon() {
            return this.withIcon ? '' : '';
        },
        dropBoxOptions() {
            return [
                {
                    text: this.$i18n.t('base.yes'),
                    option: true,
                },
                {
                    text: this.$i18n.t('base.no'),
                    option: false,
                },
            ];
        },
        computedValue() {
            return !!this.value;
        },
    },
    created() {
        this.emitValue(!!this.value);
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style scoped>
.border::v-deep {
    border: 2px solid var(--v-primary-base)!important;
    border-radius: 4px!important;
}
</style>
